export const actions = {
  UPDATE_FIGURITAS: "UPDATE_FIGURITAS",
  ALBUMS_AUTORIZADOS: "ALBUMS_AUTORIZADOS",
  MI_ALBUM: "MI_ALBUM",
  SET_CURRENTUSER: "SET_CURRENTUSER",
};
